export const tableHeaderStatementConvert = {
  'Statement Date': 'statementDate',
  'Activity Period': 'activityPeriod',
  Earnings: 'totalEarnings',
  'Subscription Fees': 'totalSubscriptionFees'
};
